export default __webpack_public_path__ + "static/media/JenVanOtterloo.d86414e9.jpg";